/*
 * @Author: huangzq
 * @Date: 2019-12-16 18:11:42
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-09-25 11:28:50
 * @Desc: 新增、编辑转载文章弹窗
*/
<template>
  <div class="reprint-article">
    <div
      v-if="isShowPage"
      class="content"
    >
      <mk-form
        ref="articleForm"
        class="form"
        :rules="rules"
        :model="dialogData"
      >
        <div class="form-title">
          <span></span>
          获取文章
        </div>
        <mk-form-item
          label="获取文章："
          prop="url"
          label-width="100px"
          class="mk-form-item-get-url"
        >
          <div class="form-url">
            <mk-input
              v-model="dialogData.url"
              width="320"
              placeholder="请粘贴微信公众号文章链接"
              class="title-input"
              clearable
              @blur="blur"
            >
            </mk-input>
            <mk-button-biz
              type="text"
              style="margin-left:15px;"
              @click="preview"
            >
              预览
            </mk-button-biz>
          </div>
          <div class="tips">
            支持微信公众号文章转载且文章内容不可编辑
          </div>
          <div
            class="show-url"
            @click="showUrl"
          >
            如何获取文章链接？
          </div>
        </mk-form-item>
        <div class="form-title setting">
          <span></span>
          文章设置
        </div>
        <mk-form-item
          ref="cover"
          label="封面图片："
          prop="cover"
          label-width="100px"
          class="mk-form-item-cover"
        >
          <mk-upload-oss
            :bucket="this.$env.VUE_APP_ALI_OSS_BUCKET"
            :limit-size="2"
            accept=".jpg,.png"
            @on-upload="onImageUpload"
          >
            <div
              v-loading="imagesLoading"
              class="upload-cover"
            >
              <div
                v-if="dialogData.cover"
                class="cover-div"
              >
                <mk-image
                  :src="dialogData.cover"
                  fit="cover"
                  class="cover-img"
                  alt="cover"
                />
                <mk-iconfont
                  icon-class="guanbihuojingshihuocuowu"
                  class="icon"
                  @click.native.stop="dialogData.cover=''"
                />
              </div>

              <mk-iconfont
                v-else
                icon-class="xinzeng"
                class="plus-icon"
              />
            </div>
          </mk-upload-oss>
          <div class="tips">
            只能上传jpg/png文件，不超过2M
          </div>
        </mk-form-item>
        <mk-form-item
          label="文章摘要："
          label-width="100px"
          prop="summary"
          class="mk-form-item-summary"
        >
          <mk-input
            v-model="dialogData.summary"
            type="textarea"
            placeholder="可简要介绍文章内容"
            maxlength="50"
            width="370"
            height="120"
            show-word-limit
            resize="none"
          />
        </mk-form-item>
        <mk-form-item
          label="分享人："
          label-width="100px"
          prop="shareName"
          class="mk-form-item-share-name"
        >
          <mk-input
            v-model="dialogData.shareName"
            placeholder="默认为文章来源"
            width="370"
            maxlength="15"
            show-word-limit
          ></mk-input>
        </mk-form-item>
        <mk-form-item
          label="打标签规则："
          label-width="100px"
          class="mk-form-item-tag-rules"
        >
          <!-- <span class="tips-rules">微信用户访问页面时，当满足符合的条件，会给他打上所设置的行为标签；多个规则同时存在时，标签会进行累加</span> -->
          <tag-rules
            ref="tagRules"
            :key="dialogData.key"
            v-model="dialogData.rules"
            :rules-data="dialogData"
            type="article"
          />
        </mk-form-item>
        <!-- 活码开关-2020-09-24 hzq 注释掉以前的活码逻辑 -->
        <mk-form-item
          v-if="false"
          label-width="100px"
          class="mk-form-item-live-code"
        >
          <span
            slot="label"
          >
            <mk-popover
              v-if="qrCodeWarningStatus"
              placement="bottom-start"
              trigger="hover"
              content="该活码已停用"
            >
              <mk-iconfont
                slot="reference"
                icon-class="jingshi"
                class="qrcode-tips"
              />
            </mk-popover>
            活码：
          </span>
          <activity-code-switch
            :dialog-data="dialogData"
            @activity-code="getActivityCode"
            @is-enable-code="getEnableCodeStatus"
          />
        </mk-form-item>
        <!-- 2020-09-24  hzq 新增的【联系员工】逻辑-->
        <activity-code-switch-biz
          :material-data="dialogData"
        />
      </mk-form>
    </div>
    <div
      v-if="isShowPage"
      class="handle"
    >
      <mk-button-biz
        width="64px"
        height="32px"
        @click="goBack"
      >
        返回
      </mk-button-biz>
      <mk-button-biz
        :loading="loading"
        width="64px"
        height="32px"
        type="primary"
        @click="checkFormData"
      >
        提交
      </mk-button-biz>
    </div>
    <get-url-tips
      v-if="show"
      :show="show"
      @cancel="cancel"
    ></get-url-tips>
    <preview
      v-if="canPreview"
      :dialog-data="dialogData"
      :show-time="showTime"
      @cancel="cancel"
    ></preview>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import { BIZAPIS } from '@api'
import tagRules from '@components/tag-rules'
import getUrlTips from './components/get-url-tips.vue'
import preview from './components/preview.vue'
import ActivityCodeSwitch from '@components/activity-code-switch'

export default {
  components: {
    tagRules,
    getUrlTips,
    preview,
    ActivityCodeSwitch
  },
  data () {
    return {
      loading: false,

      imagesLoading: false,

      rules: {
        url: [
          {
            required: true,
            message: '请粘贴微信公众号文章链接',
            trigger: 'blur'
          }
        ],
        cover: [
          { required: true, message: '请上传封面图片', trigger: 'change' }
        ],
        shareName: [
          { required: true, message: '请输入分享人', trigger: 'change' }
        ]
      },
      dialogData: {
        title: '',
        url: '',
        cover: '',
        // key: '',
        rules: [],
        shareName: '',
        context: '',
        qrCodeInfo: {
          qrCodeId: ''
        },
        summary: ''
      },
      show: false,
      canPreview: false,
      // 是否展示页面，为了保证编辑时，规则组件以及活码回显正确
      isShowPage: false,
      // 是否展示活码停用状态icon
      qrCodeWarningStatus: false,
      showTime: ''
    }
  },
  activated () {
    if (this.$route.query.id) {
      this.getInitData()
    } else {
      // 新建时直接展示页面
      this.isShowPage = true
    }
  },
  deactivated () {
    this.setFormText('')
    this.loading = false
    this.imagesLoading = false
    this.dialogData = {
      title: '',
      url: '',
      cover: '',
      // key: '',
      rules: [],
      shareName: '',
      context: '',
      qrCodeInfo: {
        qrCodeId: ''
      },
      summary: ''
    }
    this.show = false
    this.canPreview = false
    // 是否展示页面，为了保证编辑时，规则组件以及活码回显正确
    this.isShowPage = false
    // 是否展示活码停用状态icon
    this.qrCodeWarningStatus = false
    this.showTime = ''
    this.$destroy()
  },
  methods: {
    ...mapMutations('system', {
      setFormText: 'SET_FORMTEXT'
    }),
    async getInitData () {
      // 初始化数据
      const res = await MKMATERIALSVC.ArticleApi.articleFindOneGet({
        _id: this.$route.query.id
      })
      if (res.success) {
        let data = res.data
        this.dialogData.url = data.originalUrl
        this.dialogData.title = data.title
        this.dialogData.cover = data.cover
        this.dialogData.context = data.context
        this.dialogData.summary = data.summary

        this.showTime = data.showTime

        // 数据是否含有 活码信息
        if (data.qrCodeInfo) {
          this.dialogData.qrCodeInfo = data.qrCodeInfo
          // 如果活码为 停用状态，展示活码异常状态
          if (!data.qrCodeInfo.isEnable) {
            this.qrCodeWarningStatus = true
          }
        }
        // 2020-09-25 新增contactOpt字段，0:无 1:员工二维码 2:活码
        this.dialogData.contactOpt = data.contactOpt
        this.dialogData.rules = []
        this.dialogData.key = Number(new Date().getTime())
        this.dialogData.shareName = data.shareName
        this.dialogData.author = data.author
        this.setFormText(' —— ' + data.title)
        const { rules } = data

        this.dialogData.rules = rules

        // 为保证 子组件props接值正确
        this.$nextTick(() => {
          this.isShowPage = true
        })
      }
    },

    /**
     * *获取当前所选择的活码id
     */
    getActivityCode (qrCodeId) {
      this.dialogData.qrCodeInfo.qrCodeId = qrCodeId
    },
    /**
     * 当前活码为失效时，开启活码开关后，隐藏异常提示
    */
    getEnableCodeStatus (val) {
      this.qrCodeWarningStatus = val
    },
    /**
     *
     * * 图片上传事件
     */
    onImageUpload (res) {
      if (res.type === 'success') {
        this.imagesLoading = false
        this.uploadSuccess(res)
      } else if (res.type === 'fail') {
        this.imagesLoading = false
      } else if (['before', 'progress'].includes(res.type)) {
        this.imagesLoading = true
      }
    },

    /**
     * * 图片上传成功
     */
    uploadSuccess (res) {
      this.dialogData.cover = res.result.url
      this.$refs.cover.clearValidate()
    },
    /**
     * * 返回事件
     */
    goBack () {
      this.$confirm('内容将不会被保存', '', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'none'
      }).then(() => {
        history.go(-1)
      })
    },
    checkFormData () {
      this.$refs.articleForm.validate(valid => {
        if (valid) {
          if (this.$refs.tagRules.doCheck()) {
            if (this.$route.query.id) {
              this.updateReprintArticle()
            } else {
              this.addReprintArticle()
            }
          }
        }
      })
    },
    showUrl () {
      this.show = true
    },
    cancel () {
      this.show = false
      this.canPreview = false
    },
    checkDialogData () {
      if (this.dialogData.url) {
        if (this.dialogData.cover) {
          return true
        } else {
          this.$message({
            type: 'error',
            message: '请上传文章封面',
            showClose: true
          })
        }
      } else {
        this.$message({
          type: 'error',
          message: '请粘贴微信公众号文章地址',
          showClose: true
        })
      }
      return false
    },
    blur () {
      this.exchangeUrl(false)
    },
    checkUrl (state) {
      if (this.dialogData.url) {
        if (this.dialogData.url.indexOf('https://mp.weixin.qq.com') !== 0) {
          if (!state) {
            this.$message({
              type: 'error',
              message: '请粘贴微信公众号文章链接',
              showClose: true
            })
          }
          this.dialogData.url = ''
        } else {
          return true
        }
      }
      return false
    },
    async exchangeUrl (state) {
      if (this.checkUrl(state)) {
        // 转换微信文章url
        const res = await BIZAPIS.MaterialArticleApi.materialArticleReproducedPost(
          {
            url: this.dialogData.url
          }
        )
        if (res.success) {
          let data = res.data
          this.dialogData.cover = data.cover
          this.dialogData.title = data.title
          this.dialogData.context = data.body
          this.dialogData.author = data.author
          this.dialogData.shareName = data.author
          if (!data.title) {
            if (!state) {
              this.$message({
                type: 'error',
                message: '内容获取失败，请重试',
                showClose: true
              })
            }
            this.dialogData.url = ''
          } else {
            if (state) {
              this.canPreview = true
            }
          }
        }
      }
    },
    async updateReprintArticle () {
      if (this.dialogData.contactOpt === 2 && this.dialogData.qrCodeInfo.qrCodeId === '') {
        this.$message.error('请选择活码')
        return
      }
      this.loading = true
      const res = await MKMATERIALSVC.ArticleApi.articleMkUpdatePost({
        _id: this.$route.query.id,
        context: this.dialogData.context,
        cover: this.dialogData.cover,
        originalUrl: this.dialogData.url,
        sourceType: 2,
        title: this.dialogData.title,
        summary: this.dialogData.summary,
        rules: this.dialogData.rules,
        shareName: this.dialogData.shareName,
        author: this.dialogData.author,
        qrCodeId: this.dialogData.qrCodeInfo.qrCodeId,
        contactOpt: this.dialogData.contactOpt
      })
      if (res.success) {
        this.loading = false
        this.$message({
          type: 'success',
          message: '更新成功',
          showClose: true
        })
        this.$router.go(-1)
      }
    },
    async addReprintArticle () {
      this.loading = true
      // 添加转载文章
      const res = await MKMATERIALSVC.ArticleApi.articleMkCreatePost({
        context: this.dialogData.context,
        cover: this.dialogData.cover,
        originalUrl: this.dialogData.url,
        sourceType: 2,
        title: this.dialogData.title,
        summary: this.dialogData.summary,
        rules: this.dialogData.rules,
        shareName: this.dialogData.shareName,
        author: this.dialogData.author,
        qrCodeId: this.dialogData.qrCodeInfo.qrCodeId,
        contactOpt: this.dialogData.contactOpt
      })
      if (res.success) {
        this.loading = false
        this.$message({
          type: 'success',
          message: '新增成功',
          showClose: true
        })
        this.$router.go(-1)
      }
    },
    preview () {
      // 预览
      this.exchangeUrl(true)
    }
  }
}
</script>
<style lang="scss" scoped>
.reprint-article {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;

  /deep/ .el-form-item__label {
    color: #262626;
    font-size: 13px;
  }

  /deep/ .upload-cover {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    background-color: #fafafa;
    border-radius: 4px;
    border: 1px dashed #d4d4d4;

    .cover-div {
      position: relative;
      width: 60px;
      height: 60px;

      .cover-img {
        width: 100%;
        height: 100%;
      }

      .icon {
        display: none;
        position: absolute;
        top: 0;
        right: 0;
        color: #f5222d;
      }

      &:hover {
        .icon {
          display: block;
        }
      }
    }

    .plus-icon {
      font-size: 27px;
    }
  }

  .content {
    width: calc(100% - 60px);
    margin: 0 auto;
    height: 100%;
    overflow-y: auto;

    .form {
      margin: 32px 0;

      .form-title {
        display: flex;
        font-size: 14px;
        color: #262626;
        font-weight: 500;
        margin-bottom: 16px;

        span {
          display: block;
          width: 4px;
          height: 16px;
          background-color: #009cff;
          border-radius: 1px;
          margin-right: 8px;
        }
      }

      .form-title.setting {
        margin-top: 48px;
      }

      .qrcode-tips {
        color: #ff6b6b;
        font-size: 13px;
        margin-right: 6px;
      }

      .tips {
        font-size: 12px;
        color: #888;
        line-height: 17px;
        margin-top: 8px;
      }

      .show-url {
        color: #009cff;
        font-size: 12px;
        line-height: 17px;
        margin-top: 8px;
        cursor: pointer;
      }

      .tips-rules {
        color: #8c8c8c;
        font-size: 12px;
        line-height: 20px;
        display: block;
        width: 396px;
        margin-top: 10px;
      }

      .live-code {
        margin-top: 10px;

        .switch,
        .select {
          display: block;
        }

        span {
          display: block;
          color: #888;
          font-size: 12px;
        }
      }
    }
  }

  .handle {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 -2px 4px 0 rgba(5, 49, 38, 0.05);
  }

  /deep/ .el-form-item {
    margin-bottom: 20px;
  }

  .mk-form-item-get-url {
    margin-top: -20px;
  }

  .mk-form-item-summary {
    margin-top: -2px;
  }

  .mk-form-item-share-name {
    margin-top: -4px;
  }

  .mk-form-item-tag-rules {
    margin-top: -12px;

    /deep/ .tag-tip {
      margin-bottom: 16px;
    }
  }

  .mk-form-item-live-code {
    margin-top: -24px;
  }

  /deep/ .icon-mk-xinzeng {
    color: #d4d4d4 !important;
  }

  /deep/ .el-textarea {
    .el-input__count {
      background-color: transparent;
      line-height: 18px !important;
    }
  }

  /deep/ .title-input {
    input {
      padding-right: 44px;
    }

    .el-input__suffix {
      span {
        color: #909399;
        background: #fff;
        font-size: 12px;
      }
    }
  }
}
</style>
